import type { StatusTone } from "@/components/StatusBadge/StatusBadge";

export const getMemberStatusTone = (status?: string): StatusTone => {
  const normalized = (status || "").toLowerCase();
  if (["approved", "active"].includes(normalized)) return "success";
  if (["under_review", "pending"].includes(normalized)) return "warning";
  if (["rejected", "blocked", "banned"].includes(normalized)) return "danger";
  return "neutral";
};
